import React from 'react';

interface Step {
  id: number;
  label: string;
}

interface Props {
  steps: Step[];
  currentStep: number;
  title: string;
}

export default function StepHeader({ steps, currentStep, title }: Props) {
  return (
    <div className="bg-white border-b border-gray-100 sticky top-0 z-10">
      <div className="max-w-2xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between mb-3">
          <div>
            <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">{title}</p>
            <p className="text-sm font-semibold text-gray-900">
              Etapa {currentStep} de {steps.length}
            </p>
          </div>
          <div className="text-right">
            <p className="text-xs text-gray-500">{steps[currentStep - 1]?.label}</p>
          </div>
        </div>
        <div className="flex items-center gap-1">
          {steps.map((step) => (
            <div
              key={step.id}
              className={`flex-1 h-1.5 rounded-full transition-all duration-300 ${
                step.id < currentStep
                  ? 'bg-emerald-500'
                  : step.id === currentStep
                  ? 'bg-blue-500'
                  : 'bg-gray-200'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
